import { v4 as uuid } from 'uuid';
import { mergeMap, of } from "rxjs";
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';
import * as FlatModels from "@medsurf/flat-models";

@Injectable()
export class KeymapStyleEntityFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  //</editor-fold>

  //<editor-fold desc="Requests">
  
  static getNewInstance(id: string,
                        annotation: FlatModels.AnnotationEntityModels.Keymap) {
    const keymapStyle: FlatModels.KeymapStyleEntityModels.KeymapStyle = {
      id,
      color: null,
      fontSize: null,
      rowDistance: 0,
      columnDistance: 10,
      indexWidth: 10,
      keymap: annotation.id
    };
    return keymapStyle;
  }
  
  static addKeymapStyle(store: Store,
                        id: string,
                        annotation: FlatModels.AnnotationEntityModels.Keymap) {
    // Get New Instance
    const keymapStyle = KeymapStyleEntityFacade.getNewInstance(id, annotation);
    
    // Add Keymap Style
    return store.dispatch(new FlatActions.KeymapStyleEntityActions.AddEntity(keymapStyle)).pipe(
      mergeMap((data) => of({data, keymapStyle})),
    );
  }
  
  static getCopyInstance(store: Store,
                         id: string,
                         annotation: FlatModels.AnnotationEntityModels.Keymap) {
    // Get Data
    const typedKeymapStyle = store.selectSnapshot(FlatStates.KeymapStyleEntityState.typedEntities$);
    
    // Get Keymap Style
    const keymapStyle = structuredClone(typedKeymapStyle[id]);
    
    // Update Keymap Style
    keymapStyle.id = uuid();
    keymapStyle.keymap = annotation.id;
    
    return keymapStyle;
  }

  //</editor-fold>
}
